import { Button } from '@/common/components/Button'
import { SuccessCircleIcon } from '@/app/common/icons/general'
import { useNavigate } from 'react-router-dom'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useTranslation } from 'react-i18next'
import { getAttestationRoute } from '../utils'
import { useSelector } from 'react-redux'
import {
  selectFamilyApplication,
  selectSelectedStudent,
} from '@/storage/applications/familyApplicationSlice'

export const StudentSubmittedPage = () => {
  const { t: translate } = useTranslation()
  const FamilyApplicationState = useSelector(selectFamilyApplication)
  const selectedStudent = useSelector(selectSelectedStudent)
  const navigateTo = useNavigate()

  const filteredAttestations = FamilyApplicationState.attestations
    .filter((attestation) => attestation.student_id == selectedStudent?.id)
    .sort((a, b) => a.order - b.order)

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Content>
        <section
          className="flex-grow flex flex-col items-center justify-center"
          aria-labelledby="step-title"
          aria-describedby="step-desc"
        >
          <SuccessCircleIcon />
          <h3
            id="step-title"
            className="text-xl font-medium text-gray-900 mt-3"
          >
            {translate('document_submitted')}
          </h3>
          <p id="step-desc" className="text-sm text-center text-gray-900 mt-6">
            {translate('certificate_was_successfully')}.
          </p>
        </section>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar>
        <Button
          onClick={() => {
            navigateTo(getAttestationRoute(filteredAttestations))
          }}
          className="w-full h-9"
        >
          {translate('continue')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
